var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      directives: [
        {
          name: "drawerloading",
          rawName: "v-drawerloading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        "before-close": _vm.beforeCloseHandle,
        visible: _vm.visible,
        direction: "rtl",
        size:
          parseInt(_vm.size) > parseInt(_vm.maxWidth) ? _vm.maxWidth : _vm.size,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _vm._t(
        "title",
        function () {
          return [
            _c(
              "div",
              { staticClass: "version-header" },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.titleInternalKey
                        ? _vm.$t(_vm.titleInternalKey)
                        : _vm.title
                    )
                  ),
                ]),
                _c("yxt-tag", { attrs: { size: "medium" } }, [
                  _vm._v("版本：1.1"),
                ]),
              ],
              1
            ),
          ]
        },
        { slot: "title" }
      ),
      _c(
        "div",
        [
          _c(
            "yxt-form",
            { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
            [
              _vm.formCfg.nameShowState && _vm.type === "1"
                ? _c(
                    "yxt-form-item",
                    { attrs: { label: _vm.formCfg.name, prop: "name" } },
                    [
                      _c("yxt-input", {
                        attrs: {
                          maxlength: "200",
                          placeholder: _vm.$t("pc_ulcd_lbl_please_input", [
                            _vm.formCfg.name,
                          ]),
                          type: "text",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formCfg.signTimeShowState
                ? [
                    _c(
                      "yxt-form-item",
                      {
                        attrs: {
                          label: _vm.formCfg.signTime,
                          prop: "signTime",
                        },
                      },
                      [
                        _c("yxt-date-picker", {
                          staticClass: "date-picker-w",
                          attrs: {
                            type: "datetimerange",
                            "picker-options": _vm.signPickerOptions,
                            "range-separator": _vm.$t("pc_ulcd_lbl_to"),
                            "start-placeholder": _vm.$t(
                              "pc_ulcd_lbl_starttime"
                            ),
                            "end-placeholder": _vm.$t("pc_ulcd_lbl_endtime"),
                            format: "yyyy-MM-dd HH:mm",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "unlink-panels": "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.signTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "signTime", $$v)
                            },
                            expression: "form.signTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.form.signTime && _vm.form.signTime.length
                      ? [
                          _vm.formCfg.sigInPwdShowState
                            ? _c(
                                "yxt-form-item",
                                {
                                  staticClass: "yxt-form-item-level-2",
                                  attrs: {
                                    label: _vm.formCfg.sigInPwd,
                                    prop: "sigInPwd",
                                  },
                                },
                                [
                                  _c("yxt-input", {
                                    staticClass: "yxt-ulcd-sign-pwd",
                                    attrs: { maxlength: "20" },
                                    model: {
                                      value: _vm.form.sigInPwd,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "sigInPwd", $$v)
                                      },
                                      expression: "form.sigInPwd",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formCfg.timeOfAllowLate
                            ? _c(
                                "yxt-form-item",
                                {
                                  staticClass: "yxt-form-item-level-2",
                                  attrs: {
                                    label: _vm.formCfg.timeOfAllowLate,
                                    prop: "timeOfAllowLate",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.formCfg.lateFlag_allowLate[0]
                                      ) +
                                      "\n            "
                                  ),
                                  _c("yxt-input-number", {
                                    staticClass: "w-100",
                                    attrs: {
                                      controls: false,
                                      min: 0,
                                      max: 99999,
                                      precision: 0,
                                    },
                                    model: {
                                      value: _vm.form.timeOfAllowLate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "timeOfAllowLate",
                                          $$v
                                        )
                                      },
                                      expression: "form.timeOfAllowLate",
                                    },
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.formCfg.lateFlag_allowLate[1])
                                  ),
                                  _vm.lateMinuteRange
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "v-mid f-s-12 txt-grey",
                                        },
                                        [
                                          _vm._v(
                                            "（" +
                                              _vm._s(
                                                _vm.$t("pc_ulcd_lbl_delayrange")
                                              ) +
                                              "：" +
                                              _vm._s(_vm.lateMinuteRange) +
                                              "）"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm.formCfg.signoutTimeShowState
                ? [
                    _c(
                      "yxt-form-item",
                      {
                        attrs: {
                          label: _vm.formCfg.signoutTime,
                          prop: "signoutTime",
                        },
                      },
                      [
                        _c("yxt-date-picker", {
                          staticClass: "date-picker-w",
                          attrs: {
                            type: "datetimerange",
                            "picker-options": _vm.signoutPickerOptions,
                            "range-separator": _vm.$t("pc_ulcd_lbl_to"),
                            "start-placeholder": _vm.$t(
                              "pc_ulcd_lbl_starttime"
                            ),
                            "end-placeholder": _vm.$t("pc_ulcd_lbl_endtime"),
                            format: "yyyy-MM-dd HH:mm",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "unlink-panels": "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.signoutTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "signoutTime", $$v)
                            },
                            expression: "form.signoutTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.formCfg.sigOutPwdShowState &&
                    _vm.form.signoutTime &&
                    _vm.form.signoutTime.length
                      ? _c(
                          "yxt-form-item",
                          {
                            staticClass: "yxt-form-item-level-2",
                            attrs: {
                              label: _vm.formCfg.sigOutPwd,
                              prop: "sigOutPwd",
                            },
                          },
                          [
                            _c("yxt-input", {
                              staticClass: "yxt-ulcd-sign-pwd",
                              attrs: { maxlength: "20" },
                              model: {
                                value: _vm.form.sigOutPwd,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "sigOutPwd", $$v)
                                },
                                expression: "form.sigOutPwd",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm.formCfg.locationNameShowState
                ? _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.formCfg.locationName,
                        prop: "locationName",
                        rules: {
                          required:
                            _vm.form.canFence === 1 &&
                            !_vm.functionPoints.hidden &&
                            !_vm.functionPoints.disabled,
                          message: _vm.$t("pc_ulcd_placeholder_attendaddress"),
                          trigger: "change",
                        },
                      },
                    },
                    [
                      _c(
                        "yxt-input",
                        {
                          attrs: {
                            readonly: "",
                            autocomplete: "off",
                            placeholder: _vm.$t(
                              "pc_ulcd_placeholder_attendaddress"
                            ),
                          },
                          model: {
                            value: _vm.form.locationName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "locationName", $$v)
                            },
                            expression: "form.locationName",
                          },
                        },
                        [
                          _c(
                            "yxt-link",
                            {
                              staticClass:
                                "layout-flex layout-align-center c-43 hand",
                              attrs: { slot: "suffix", underline: false },
                              on: { click: _vm.selectAdress },
                              slot: "suffix",
                            },
                            [
                              _c("i", {
                                staticClass: "yxt-icon-location-outline mr4",
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("pc_ulcd_lbl_offline_mapaddress")
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formCfg.addressShowState
                ? _c(
                    "yxt-form-item",
                    {
                      staticClass: "mb10",
                      attrs: {
                        prop: "address",
                        rules: {
                          required: _vm.form.canFence === 1,
                          message: _vm.$t("pc_ulcd_placeholder_detailaddress"),
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("yxt-input", {
                        attrs: {
                          autocomplete: "off",
                          maxlength: "50",
                          placeholder: _vm.$t(
                            "pc_ulcd_placeholder_detailaddress"
                          ),
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "address", $$v)
                          },
                          expression: "form.address",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formCfg.canFenceShowState && !_vm.functionPoints.hidden
                ? _c(
                    "yxt-form-item",
                    { staticClass: "mb0", attrs: { prop: "canFence" } },
                    [
                      _c(
                        "yxt-col",
                        [
                          _c(
                            "yxt-checkbox",
                            {
                              attrs: {
                                disabled: _vm.functionPoints.disabled,
                                "true-label": 1,
                                "false-label": 2,
                              },
                              model: {
                                value: _vm.form.canFence,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "canFence", $$v)
                                },
                                expression: "form.canFence",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("pc_ulcd_lbl_offline_enclosure")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _c(
                            "yxt-tooltip",
                            {
                              staticClass: "item v-mid ml8",
                              attrs: {
                                content: _vm.functionPoints.disabled
                                  ? _vm.$t("pc_ulcd_msg_permission_error")
                                  : _vm.$t("pc_ulcd_tip_clockintip"),
                                effect: "light",
                                placement: "right",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "yxt-icon-warning-outline",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.canFence === 1 && !_vm.functionPoints.hidden
                ? _c(
                    "yxt-form-item",
                    [
                      _c("span", { staticClass: "mr4" }, [
                        _vm._v(_vm._s(_vm.$t("pc_ulcd_lbl_attendScope"))),
                      ]),
                      _c("yxt-input-number", {
                        staticClass: "mr4 ml4",
                        attrs: {
                          "controls-position": "right",
                          min: 1,
                          max: 20,
                          "step-strictly": "",
                          disabled: _vm.functionPoints.disabled,
                        },
                        model: {
                          value: _vm.form.attendanceRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "attendanceRange", $$v)
                          },
                          expression: "form.attendanceRange",
                        },
                      }),
                      _c("span", { staticClass: "mr4" }, [
                        _vm._v(_vm._s(_vm.$t("pc_ulcd_lbl_attendScopeKm"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formCfg.canScanCodeShowState
                ? _c(
                    "yxt-form-item",
                    { attrs: { prop: "canScanCode" } },
                    [
                      _c(
                        "yxt-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.form.canScanCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "canScanCode", $$v)
                            },
                            expression: "form.canScanCode",
                          },
                        },
                        [_vm._v(_vm._s(_vm.formCfg.canScanCode))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "yxt-form-item",
                {
                  staticClass: "mb0",
                  attrs: { label: _vm.$t("pc_ulcd_lbl_remarkperson") },
                },
                [
                  _c(
                    "yxt-radio-group",
                    {
                      attrs: { direction: "row" },
                      model: {
                        value: _vm.form.remarkType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "remarkType", $$v)
                        },
                        expression: "form.remarkType",
                      },
                    },
                    [
                      _c("yxt-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("pc_ulcd_lbl_instructorremark"))),
                      ]),
                      _c(
                        "yxt-radio",
                        { attrs: { label: 5 } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("pc_ulcd_lbl_designpersonremark"))
                          ),
                          _vm.form.remarkType === 5
                            ? _c(
                                "yxt-button",
                                {
                                  staticClass: "ml16",
                                  attrs: { type: "primary" },
                                  on: { click: _vm.showUsersBox },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("pc_ulcd_lbl_designperson"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "yxt-form-item",
                { attrs: { prop: "users" } },
                [
                  _vm.form.users.length > 0 && _vm.form.remarkType === 5
                    ? _vm._l(_vm.form.users, function (user) {
                        return _c(
                          "yxt-tag",
                          {
                            key: user.id,
                            staticClass: "ml5",
                            attrs: { type: "info", closable: "" },
                            on: {
                              close: function ($event) {
                                return _vm.delUser(user)
                              },
                            },
                          },
                          [
                            _c("yxtbiz-user-name", {
                              attrs: { name: user.fullname },
                            }),
                          ],
                          1
                        )
                      })
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "yxt-form-item",
                { attrs: { label: _vm.$t("pc_ulcd_lbl_evaluate") } },
                [
                  _c("div", { staticClass: "layout-flex" }, [
                    _c(
                      "div",
                      { staticClass: "layout-flex" },
                      [
                        _c(
                          "yxt-form-item",
                          {
                            staticClass: "d-in-block v-mid",
                            attrs: { "label-width": "0", prop: "targetCheck" },
                          },
                          [
                            _c(
                              "yxt-checkbox",
                              {
                                attrs: {
                                  disabled:
                                    !!_vm.form.targetId && _vm.qnrCanEdit !== 0,
                                },
                                on: { change: _vm.removeSource },
                                model: {
                                  value: _vm.form.targetCheck,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "targetCheck", $$v)
                                  },
                                  expression: "form.targetCheck",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("pc_ulcd_lbl_evaluate_stu")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "yxt-form-item",
                          {
                            staticClass: "d-in-block v-mid",
                            attrs: { "label-width": "0", prop: "targetId" },
                          },
                          [
                            _vm.form.targetCheck
                              ? _c(
                                  "yxt-button",
                                  {
                                    staticClass: "ml12 v-mid",
                                    attrs: {
                                      type: "primary",
                                      disabled:
                                        !!_vm.form.targetId &&
                                        _vm.qnrCanEdit !== 0,
                                    },
                                    on: { click: _vm.showSelectHandle },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("pc_ulcd_btn_selecttemplate")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.form.targetId
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-flex-1 over-hidden layout-flex layout-align-center",
                          },
                          [
                            _c(
                              "yxt-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "light",
                                  content: _vm.form.targetName,
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "nowrap ellipsis ml8 v-mid" },
                                  [_vm._v(_vm._s(_vm.form.targetName))]
                                ),
                              ]
                            ),
                            !!_vm.form.targetId
                              ? _c("ulcd-svg", {
                                  staticClass:
                                    "hand c-bf v-mid ml8 hover-primary-6 flex-shrink-0",
                                  attrs: {
                                    back: "",
                                    name: "close",
                                    width: "20px",
                                    height: "20px",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.removeSource.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm.visible
                ? _c(
                    "upload-refs",
                    {
                      ref: "upload",
                      attrs: {
                        buttonType: "second",
                        label: _vm.$t("pc_ulcd_offline_enclosure"),
                        files: _vm.form.files,
                        limit: 5,
                        "app-code": _vm.appCode,
                      },
                    },
                    [
                      _c(
                        "yxt-tooltip",
                        {
                          staticClass: "item v-mid ml8",
                          attrs: {
                            slot: "toolTip",
                            content: _vm.$t("pc_ulcd_msg_filemessage"),
                            effect: "light",
                            placement: "top",
                          },
                          slot: "toolTip",
                        },
                        [
                          _c("ulcd-svg", {
                            staticClass: "c-bf",
                            attrs: {
                              width: "16px",
                              height: "16px",
                              name: "icons/question-cirlce-o",
                              back: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.beforeCloseHandle } },
            [_vm._v(_vm._s(_vm.$t("pc_ulcd_btn_cancel")))]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitHandle } },
            [_vm._v(_vm._s(_vm.$t("pc_ulcd_btn_done")))]
          ),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          attrs: {
            title: _vm.$t("pc_ulcd_lbl_select_survey"),
            "append-to-body": "",
            "destroy-on-close": "",
            "before-close": _vm.hiddenSelect,
            visible: _vm.showSelect,
            size: "960px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelect = $event
            },
          },
        },
        [
          _c("yxtbiz-survey-template", {
            attrs: {
              type: 1,
              functionCode: "survey_template",
              dataPermissionCode: "investigate_moudle_extent",
              selected: _vm.form.targetId,
            },
            on: { select: _vm.sourceSelect },
          }),
        ],
        1
      ),
      _c("map-address", {
        attrs: {
          mapAddress: _vm.currentMapInfo,
          visible: _vm.centerDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.centerDialogVisible = $event
          },
          mapAdressChange: _vm.mapAdressChange,
        },
      }),
      _c("people-select", {
        ref: "selector",
        attrs: {
          users: _vm.form.users,
          groupOrgFlag: _vm.groupOrgFlag,
          bizComponentConfig: _vm.bizComponentConfig,
          visible: _vm.personSelectDialog,
        },
        on: {
          getUsers: _vm.getUsers,
          "update:visible": function ($event) {
            _vm.personSelectDialog = $event
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }